<template>
    <div class="giftCardList ">
        <div class="kettlCards">
            
            <router-link v-if="firstwallet" :to="{name: 'EditGiftCard',params: {cardId: firstwallet.card_id }}" class="card" style="width: 100%">
                <div class="title h2">
                    My Wallet
                </div>
                <div class="purchased h4">
                    Balance ${{ totalCount }}
                </div>
                <div class="username caption">
                    <div class="name">
                        {{ user.first_name}} {{ user.last_name }}
                    </div>
                </div>
            </router-link>
            <div v-else class="card" style="width: 100%">
                <div class="title h2">
                    My Wallet
                </div>
                <div class="purchased h4">
                    Balance ${{ totalCount }}
                </div>
                <div class="username caption">
                    <div class="name">
                        {{ user.first_name}} {{ user.last_name }}
                    </div>
                </div>
            </div>
            
        </div>
        <div class="text-center" v-if="firstwallet">
            <router-link :to="{name: 'My-wallet',params: {cardId: firstwallet.card_id }}" class="smlBtn mt-2">
                Load Wallet
            </router-link>
        </div>
        <div class="text-center" v-else>
            <router-link :to="{name: 'My-wallet'}" class="smlBtn mt-2">
                Load Wallet
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "GiftCardsList",
        props: ["showCheckoutCheckBox"],
        data() {
            return {
                gift_cards: null,
                firstwallet: null,
                total: 0
            }
        },
        created() {
            this.$store.dispatch("cart/getGiftCards", {
                callback: (data) => {
                    this.gift_cards = data;
                    this.gift_cards?.map(gc => {
                        if(gc.gift_card_type_id == 1996) {
                            this.total += parseFloat(gc.balance);
                            if( this.firstwallet == null){
                                this.firstwallet = gc;
                            }
                        }
                    });
                }
            });
        },
        computed: {
            totalCount(){
                return this.total.toFixed(2);
            }
        }
    }
</script>
